module.exports = __webpack_public_path__ + "media/images/partner-alt-1-39b75cde605d8b91dac69856e68a1d42.png";